export const B010010CreateRequestFieldName = {
  juchuKbn: "受注区分",
  juchudenpyoNo: "受注伝票番号",
  juchuYmd: "受注日",
  nohinyoteiYmd: "必着日",
  tokuiCd: "得意先コード",
  tokuishitenCd: "得意先支店コード",
  tokuiNm: "得意先名",
  nonyuCd: "納入先コード",
  nonyushitenCd: "納入先支店コード",
  nonyuNm: "納入先名",
  shainCd: "社員コード",
  seisakuYmd: "製作日",
  shukayoteiYmd: "発送日",
  jisanYmd: "持参日",
  denpyoYmd: "伝票日付",
  chohaKbn: "帳端区分",
  hasosakiCd: "発送先コード",
  hasokbnCd: "発送区分コード",
  assistantCd: "アシスタントコード",
  denpyoshubetsuCd: "伝票種別コード",
  tenpudenpyoCd: "添付伝票コード",
  unsogaishaCd: "運送会社コード",
  bumonCd: "部門コード",
  ppgakeKbn: "PPがけ区分",
  netsukeKbn: "値付け区分",
  bikoCd: "備考コード",
  lineCd: "ラインコード",
  b010010MeiRequest: {
    b010010MeiRequest: "明細",
    juchugyoNo: "受注行番号",
    uchiwakeKbn: "内訳区分",
    shohinCd: "商品コード",
    sokoCd: "倉庫コード",
    juchusu: "受注数",
    tenyuryokujodaiKbn: "手入力上代区分",
    tenyuryokujuchuKbn: "手入力受注区分",
    juchutanka: "受注単価",
    kakeritsu: "掛率",
    meisaibikoCd: "明細備考コード",
    kazeiKbn: "課税区分",
    setshohinKbn: "セット商品区分",
    b010010MeiKoseiRequest: {
      b010010MeiKoseiRequest: "構成",
      juchugyoNo: "受注行番号",
      juchukoseigyoNo: "受注構成行番号",
      shohinCd: "商品コード",
      sokoCd: "倉庫コード",
      koseisu: "構成数",
      tenyuryokujodaiKbn: "手入力上代区分",
      tenyuryokujuchuKbn: "手入力受注区分",
      juchutanka: "受注単価",
      kakeritsu: "掛率",
      juchuKin: "受注金額",
      meisaikoseiBikoCd: "構成明細備考コード",
      meisaikoseiBiko: "構成明細備考",
      kazeiKbn: "課税区分",
    },
  },
};
